const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assignment templates Manager Directive to display a list or table with templates to manage
 */
app.directive('assignmentTemplatesManager', ['Navigation', 'Messaging', 'AssignmentTemplates', 'Features', '$translate', function (Navigation, Messaging, AssignmentTemplates, Features, $translate) {
  return {
    restrict: 'E',
    scope: {
      newTemplate: '=?',
      refresh: '=',
      assignmentsRefresh: '='
    },
    replace: true,
    template: require('../../../templates/directives/assignments/assignment-templates-manager.html'),
    controller: ['$scope', function ($scope) {
      const self = this;

      if (!Features.flags().enable_assignment_templates) {
        Navigation.goToHome();
        return;
      }

      self.initialized = false;
      self.loading = false;
      self.assignmentTemplates = [];

      self.paginate = {
        perPage: 10,
        page: 0,
        emptyPage: false,
        nextPage: async function () {
          this.page++;
          await checkForSearchAndLoad();
        },
        previousPage: async function () {
          if (this.emptyPage) {
            this.emptyPage = false;
          }
          this.page--;
          await checkForSearchAndLoad();
        }
      }

      self.search = {
        query: {},
        existingQuery: function() {
          return Object.keys(self.search.query).length > 0;
        },
        onQuery: async function(items) {
          self.search.query = {};
          const objs = [];
          let text = '';
          items.forEach(item => {
            if (item._id) {
              objs.push(item._id)
            } else {
              text = item.title;
            }
          })

          if (objs.length) {
            this.query._id = objs;
          }
          if (text.length) {
            this.query.term = text;
          }

          self.paginate.page = 0;
          await self.load(self.search.query);
        },
      }

      self.load = async function(query) {
        self.loading = true;
        try {
          const queryWithArchive = {...query};
          const list = await AssignmentTemplates.find({
            page: self.paginate.page,
            perPage: self.paginate.perPage,
            query: queryWithArchive,
            includeDeliveries: true
          }).$promise;

          if (list.length < self.paginate.perPage) {
            self.paginate.emptyPage = true;
          }
          if (list.length === self.paginate.perPage) {
            self.paginate.emptyPage = false;
          }
          if (list.length === 0 && self.paginate.page > 0) {
            self.paginate.emptyPage = true;
            self.paginate.page--;
            self.loading = false;
            $scope.$apply();
            return;
          }

          self.assignmentTemplates = list;
          self.loading = false;
          self.initialized = true;
          $scope.$apply();
        } catch (err) {
          Messaging.addMessage({type: 'error', duration: 5, text: self.translations['assignmentTemplates.find.error'] });
          console.log(err);
        }
      }

      const checkForSearchAndLoad = async function() {
        if (self.search.existingQuery()) {
          await self.load(self.search.query);
        } else {
          await self.load();
        }
      }

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        },
      };

      self.closeCreating = function() {
        $scope.newTemplate = false;
      };

      self.editing = {
        active: null,
        setActive: function(id) {
          self.editing.active = id;
        },
        closeEdit: function(changed) {
          self.editing.active = null;
          self.editMenu.visible = false;
          self.closeCreating();
          if (changed) {
            self.load();
          }
        }
      };

      self.distributing = {
        active: null,
        setActive: function(id) {
          self.distributing.active = id;
        },
        closeDistributing: function(changed) {
          self.distributing.active = null;
          self.editMenu.visible = false;
          if (changed) {
            $scope.assignmentsRefresh = true;
            self.load();
          }
        }
      };

      $scope.$watch('refresh', async function(newVal, oldVal) {
        if (!self.initialized || !newVal || newVal === oldVal) {
          return;
        }
        await checkForSearchAndLoad();
        $scope.refresh = false;
      });

      self.initialize = async function() {
        self.translations = await $translate([
          'assignmentTemplates.find.error'
        ]);
        self.load();
      };

      self.initialize();
    }],
    controllerAs: 'templateCtrl'
  }
}]);